(function() {
    function getSectionsToRender() {
        return [
            {
                selector: "js-main-product",
                sectionId: document.querySelector("[js-main-product]")?.dataset.section
            },
            {
                selector: "js-product-ingredient-section",
                sectionId: document.querySelector('[js-product-ingredient-section]')?.dataset.section
            },
            {
                selector: "js-product-neutrition-section",
                sectionId: document.querySelector('[js-product-neutrition-section]')?.dataset.section
            },
            {
                selector: "js-product-review-section",
                sectionId: document.querySelector('[js-product-review-section]')?.dataset.section
            },
            {
                selector: "js-product-faq-section",
                sectionId: document.querySelector('[js-product-faq-section]')?.dataset.section
            },
            {
                selector: "js-product-related-product-section",
                sectionId: document.querySelector('[js-product-related-product-section]')?.dataset.section
            },
            {
                selector: "js-product-instagram-main-section",
                sectionId: document.querySelector('[js-product-instagram-main-section]')?.dataset.section
            },
            {
                selector: "js-product-newsletter-main-section",
                sectionId: document.querySelector('[js-product-newsletter-main-section]')?.dataset.section
            },
        ]
    }

    function renderSections(handle) {
        getSectionsToRender().forEach(section=>{
            fetch(`/products/${handle}?section_id=${section.sectionId}`).then(response=>response.text()).then(html => {
                const doc = new DOMParser().parseFromString(html, "text/html");
                  
                const elementToReplace = document.querySelector(`[${section.selector}]`);
                  elementToReplace.innerHTML ='';
    
                if(elementToReplace) {
                    if(doc.querySelector(`[${section.selector}]`)) {
                        elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`).innerHTML
                    }
                };
    
                if(section.selector === "js-product-faq-section") {
                    document.dispatchEvent(new CustomEvent("accordion:init"))
                };
    
                if(section.selector === "js-product-instagram-main-section") {
                    document.dispatchEvent(new CustomEvent("marquee:init"))
                }

                if(section.selector === "js-product-ingredient-section") {
                   document.dispatchEvent(new CustomEvent("productIngredientTab:init"))
                }
    
                if(section.selector === "js-main-product") {
                    document.dispatchEvent(new CustomEvent("mainProduct:variant:custom"));
                    document.dispatchEvent(new CustomEvent("customProductsList:drop"));
                    document.dispatchEvent(new CustomEvent("activeSelectedProduct")); 
                    document.dispatchEvent(new CustomEvent("init:autoCloseDrop"));
                    document.dispatchEvent(new CustomEvent("accordionProductSection:init"));
                    // subscription
                    yotpoWidgetsContainer.initWidgets()
                };

                if(section.selector === "js-product-review-section") {
                    yotpoWidgetsContainer.initWidgets()
                };
                
                if(section.selector === "js-product-related-product-section") {
                    setTimeout(() => yotpo.initWidgets(), 5000)
                };

                document.body.classList.remove("disabled");
    
                if(section.selector === 'js-product-neutrition-section') {
                    document.dispatchEvent(new CustomEvent("nutritionSlider:init"))
                }
            }
            ).catch(function(error) {
                console.log(error)
            })
        }
        )
    }

    function updateSelectedProductsDrop(currentTarget) {
        currentTarget.closest('[js-select]').querySelector('[js-dropdown-icon]').classList.remove('icon-rotate')
        currentTarget.closest('[js-select]').querySelector('[js-dropdown-menu]').classList.remove('open-menu')

        // document.dispatchEvent(new CustomEvent('activeSelectedProduct'))
    }
    
    class productListOption extends HTMLElement {
        constructor() {
            super(),
            this.selectors = {
                dropItem: "[js-drop-item]",
                swatchHandle: "[js-swatch-handle]"
            },
            this.classes = {
                activeClass: "active"
            },
            this.dropItems = this.querySelectorAll(this.selectors.dropItem),
            this.swatchHandle = this.querySelector(this.selectors.swatchHandle),
            this.init()
        }
        init() {
            this.querySelectorAll("[js-swatch-item][data-solid-item]:not(.hidden)").length == 0 ? document.querySelector("[data-solid-label]") != null && document.querySelector("[data-solid-label]").classList.add("hidden") : document.querySelector("[data-solid-label]") != null && document.querySelector("[data-solid-label]").classList.remove("hidden"),
            this.querySelectorAll("[js-swatch-item][data-print-item]:not(.hidden)").length == 0 ? document.querySelector("[data-print-label]") != null && document.querySelector("[data-print-label]").classList.add("hidden") : document.querySelector("[data-print-label]") != null && document.querySelector("[data-print-label]").classList.remove("hidden"),
            this.dropItems.forEach(swatchItem=>{
                swatchItem.addEventListener("click", ({currentTarget})=>{
                    this.toggleProduct(currentTarget)
                }
                )
            }
            )
        }
        toggleProduct(targetProduct) {
            const productHandle = targetProduct.dataset.productHandle
              , swatchHandle = targetProduct.dataset.swatchHandle;
            console.log({productHandle})
            this.updateHistoryState(productHandle),
            renderSections(productHandle),
            updateSelectedProductsDrop(targetProduct),
            this.updateState(targetProduct)
        }
        updateState(targetEl) {
            document.body.classList.add("disabled")
            // this.dropItems.forEach(item=>item.classList.remove(this.classes.activeClass)),
            // targetEl.classList.add(this.classes.activeClass)
        }
        updateHistoryState(handle) {
            var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
            window.history.pushState({
                path: newurl
            }, "", newurl)
        }
    }
    customElements.define("product-list-option", productListOption)
}
)();

function customProductListDrop() {
    const dropdown = document.querySelectorAll('[js-dropdown]');
    dropdown.forEach(drop => {
        const dropdownSelect = drop.querySelector('[js-select]');
        const selectedOption = drop.querySelector('[js-selected-option]');
        const dropdownIcon = drop.querySelector('[js-dropdown-icon]');
        const dropdownMenu = drop.querySelector('[js-dropdown-menu]');
        const dropdownList = drop.querySelectorAll('[js-dropdown-item]');
        const dropdownSelectedList = drop.querySelector('[js-dropdown-icon]');
        
        const selectedOptionTitle = document.querySelector('[js-selected-name]')
        const selectedOptionColor = document.querySelector('[js-selected-color]')
        
        if(dropdownSelect) {
            dropdownSelect.addEventListener("click", () => {
              dropdownIcon.classList.toggle("icon-rotate");
              dropdownMenu.classList.toggle("open-menu");
            })
        }

    })

}



customProductListDrop()
document.addEventListener('customProductsList:drop', customProductListDrop)

document.addEventListener('DOMContentLoaded', function() {
    function getSelected() {
        const container = document.querySelector('[js-custom-product-section]')
        const pathName_ = window.location.pathname
        const pathArray = pathName_.split('/products/')

        const selectedElement = container.querySelector('[js-selected-option]')
    
        // all products handle
        const allProducts_ = Array.from(container.querySelectorAll('[js-dropdown-menu] li'))
  
    
    }
    getSelected()
    autoCloseCustomDrop() 
    // document.addEventListener('activeSelectedProduct', getSelected)
    document.addEventListener('init:autoCloseDrop', autoCloseCustomDrop)

    function autoCloseCustomDrop() {
        document.addEventListener('click', function(e) {
            if(!e.target.closest('[js-dropdown]')) {
                const menu_ = document.querySelectorAll('[js-dropdown-menu]')
                const dropIcon = document.querySelectorAll('[js-dropdown-icon]')
                
                menu_.forEach((menuItem, index) => {
                    if(menuItem.classList.contains('open-menu')) {
                        menuItem.classList.remove('open-menu')
                        dropIcon[index].classList.remove('icon-rotate')
                    }
                })

            }

           
        })
    }

    
})

